(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer) {
    const itemsEl = drawer.querySelector('[data-cd-items]');
    const emptyEl = drawer.querySelector('[data-cd-empty]');
    const footEl = drawer.querySelector('[data-cd-foot]');
    const countEl = drawer.querySelector('[data-cd-count]');
    const subtotalEl = drawer.querySelector('[data-cd-subtotal]');
    const removeLabel = drawer.dataset.removeLabel || 'Remove';

    const money = (cents) =>
      new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: drawer.dataset.currency || 'RON',
      }).format(cents / 100);

    const esc = (s) =>
      String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

    const thumb = (url) => url + (url.includes('?') ? '&' : '?') + 'width=320';

    const render = (cart) => {
      const empty = cart.item_count === 0;
      emptyEl.hidden = !empty;
      footEl.hidden = empty;
      countEl.textContent = empty ? '' : '· ' + cart.item_count;
      subtotalEl.textContent = money(cart.total_price);
      itemsEl.innerHTML = cart.items
        .map((item) => {
          const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          return (
            '<div class="cart-drawer__item" data-key="' + esc(item.key) + '">' +
            (item.image
              ? '<a href="' + esc(item.url) + '" tabindex="-1"><img src="' + esc(thumb(item.image)) + '" width="160" height="240" alt=""></a>'
              : '') +
            '<div class="cart-drawer__info">' +
            '<p class="cart-drawer__product"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></p>' +
            (variant ? '<p class="cart-drawer__variant">' + esc(variant) + '</p>' : '') +
            '<p class="cart-drawer__price">' + money(item.final_line_price) + '</p>' +
            '<div class="cart-drawer__line">' +
            '<span class="cart-drawer__qty">' +
            '<button type="button" data-cd-qty="-1" aria-label="&minus;1">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-cd-qty="1" aria-label="+1">+</button>' +
            '</span>' +
            '<button type="button" class="cart-drawer__remove" data-cd-remove>' + esc(removeLabel) + '</button>' +
            '</div></div></div>'
          );
        })
        .join('');

      const header = document.querySelector('.site-header__cart');
      if (header) {
        let bubble = header.querySelector('.site-header__cart-count');
        if (empty) {
          if (bubble) bubble.remove();
        } else {
          if (!bubble) {
            bubble = document.createElement('span');
            bubble.className = 'site-header__cart-count';
            bubble.setAttribute('aria-hidden', 'true');
            header.append(bubble);
          }
          bubble.textContent = cart.item_count;
        }
      }
    };

    const refresh = () => fetch('/cart.js').then((r) => r.json()).then(render);

    window.AlinetteCartDrawer = {
      open: () =>
        refresh().then(() => {
          if (!drawer.open) drawer.showModal();
        }),
    };

    // Quantity steppers and remove, delegated so re-renders keep working
    itemsEl.addEventListener('click', (e) => {
      const qtyBtn = e.target.closest('[data-cd-qty]');
      const removeBtn = e.target.closest('[data-cd-remove]');
      if (!qtyBtn && !removeBtn) return;
      const row = e.target.closest('[data-key]');
      if (!row) return;
      const current = parseInt(row.querySelector('.cart-drawer__qty span').textContent, 10) || 0;
      const quantity = removeBtn ? 0 : Math.max(0, current + parseInt(qtyBtn.dataset.cdQty, 10));
      row.classList.add('cart-drawer__item--busy');
      const key = row.dataset.key;
      const showRowError = (msg) => {
        const target = itemsEl.querySelector('[data-key="' + CSS.escape(key) + '"] .cart-drawer__info');
        if (!target) return;
        let note = target.querySelector('.cart-drawer__row-error');
        if (!note) {
          note = document.createElement('p');
          note.className = 'cart-drawer__row-error';
          target.append(note);
        }
        note.textContent = msg;
      };
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then((r) => {
          if (r.ok) return r.json().then(render);
          // 422 = quantity above available stock; show Shopify's message
          return r
            .json()
            .catch(() => ({}))
            .then((err) =>
              refresh().then(() => showRowError(err.description || err.message || drawer.dataset.stockError))
            );
        })
        .catch(refresh);
    });

    drawer.querySelectorAll('[data-cd-close]').forEach((el) => {
      el.addEventListener('click', () => drawer.close());
    });
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) drawer.close();
    });

    // Header cart icon opens the drawer instead of navigating; the /cart
    // page stays reachable as the no-JS fallback
    document.querySelectorAll('.site-header__cart').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const menu = document.querySelector('.site-header details[open]');
        if (menu) menu.removeAttribute('open');
        window.AlinetteCartDrawer.open();
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Intent-based warm-up: on hover/touch/focus of a [data-warm-profile]
  // link, prefetch the destination page and preload the exact image
  // variant the next page will request (mirrors srcset selection).
  if (!window.__alinetteWarm) {
    window.__alinetteWarm = true;
    const warmed = new Set();

    const pickWidth = (profile) => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const conf =
        profile === 'card'
          ? { frac: window.matchMedia('(min-width: 750px)').matches ? 0.5 : 1, widths: [400, 750, 1100, 1500] }
          : { frac: window.matchMedia('(min-width: 990px)').matches ? 0.6 : 1, widths: [550, 900, 1300, 1800] };
      const target = window.innerWidth * conf.frac * dpr;
      return conf.widths.find((w) => w >= target) || conf.widths[conf.widths.length - 1];
    };

    const warm = (el) => {
      const key = el.getAttribute('href') || el.dataset.warmImages;
      if (!key || warmed.has(key)) return;
      warmed.add(key);
      if (el.dataset.warmPage !== undefined && el.getAttribute('href')) {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = el.getAttribute('href');
        document.head.append(link);
      }
      const width = pickWidth(el.dataset.warmProfile);
      (el.dataset.warmImages || '')
        .split('|')
        .filter(Boolean)
        .forEach((src) => {
          new Image().src = src.replace(/([?&])width=1800/, '$1width=' + width);
        });
    };

    ['pointerover', 'touchstart', 'focusin'].forEach((evt) => {
      document.addEventListener(
        evt,
        (e) => {
          const el = e.target.closest && e.target.closest('[data-warm-profile]');
          if (el) warm(el);
        },
        { capture: true, passive: true }
      );
    });
  }
  } catch(e) { console.error(e); }
})();

})();
